import { render } from "./studentApply.vue?vue&type=template&id=05232d69&scoped=true"
import script from "./studentApply.vue?vue&type=script&lang=js"
export * from "./studentApply.vue?vue&type=script&lang=js"

import "./studentApply.vue?vue&type=style&index=0&id=05232d69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05232d69"]])

export default __exports__